export const validateMobile = (mobile) => {
  const pattern = /^(?:[+0]9)?[0-9]{7,15}$/;
  return pattern.test(mobile);
};